var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6117_14790)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6117_14790)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6117_14790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57519 2.39355C7.02291 2.39355 6.5752 2.84127 6.5752 3.39355V20.3936C6.5752 20.9458 7.02291 21.3936 7.5752 21.3936H20.5752C21.1275 21.3936 21.5752 20.9458 21.5752 20.3936V7.91987H19.0659C17.4091 7.91987 16.0659 6.57673 16.0659 4.91987V2.39355H7.57519ZM18.0659 3.81306L20.1662 5.91987H19.0659C18.5137 5.91987 18.0659 5.47216 18.0659 4.91987V3.81306ZM4.5752 3.39355C4.5752 1.7367 5.91834 0.393555 7.57519 0.393555H17.4811L23.5752 6.50656V20.3936C23.5752 22.0504 22.232 23.3936 20.5752 23.3936H7.5752C5.91834 23.3936 4.5752 22.0504 4.5752 20.3936V3.39355Z",
    fill: "#0043A1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2.5752 8.19336C2.5752 7.36493 3.24677 6.69336 4.0752 6.69336H14.0752C14.9036 6.69336 15.5752 7.36493 15.5752 8.19336V11.4934C15.5752 12.3218 14.9036 12.9934 14.0752 12.9934H4.0752C3.24677 12.9934 2.5752 12.3218 2.5752 11.4934V8.19336Z",
    fill: "#0043A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9541 11.3935V8.48438H6.04501C6.2685 8.48438 6.456 8.52604 6.60751 8.60938C6.75997 8.69271 6.87503 8.80729 6.95268 8.95312C7.03128 9.09801 7.07058 9.26278 7.07058 9.44744C7.07058 9.634 7.03128 9.79972 6.95268 9.9446C6.87408 10.0895 6.75808 10.2036 6.60467 10.2869C6.45126 10.3693 6.26234 10.4105 6.03791 10.4105H5.3149V9.97727H5.96689C6.09757 9.97727 6.20457 9.95455 6.28791 9.90909C6.37124 9.86364 6.43279 9.80114 6.47257 9.72159C6.51329 9.64205 6.53365 9.55066 6.53365 9.44744C6.53365 9.34422 6.51329 9.25331 6.47257 9.17472C6.43279 9.09612 6.37077 9.03504 6.28649 8.99148C6.20315 8.94697 6.09567 8.92472 5.96404 8.92472H5.48109V11.3935H4.9541Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01412 11.3935H8.02832V8.48438H9.034C9.32283 8.48438 9.57093 8.54261 9.77832 8.65909C9.98665 8.77462 10.1467 8.94081 10.2584 9.15767C10.3702 9.37453 10.426 9.634 10.426 9.93608C10.426 10.2391 10.3697 10.4995 10.257 10.7173C10.1453 10.9351 9.98381 11.1023 9.77264 11.2188C9.56241 11.3352 9.30957 11.3935 9.01412 11.3935ZM8.55531 10.9375H8.98855C9.1912 10.9375 9.36023 10.9006 9.49565 10.8267C9.63107 10.7519 9.73287 10.6406 9.80105 10.4929C9.86923 10.3442 9.90332 10.1586 9.90332 9.93608C9.90332 9.71354 9.86923 9.52888 9.80105 9.3821C9.73287 9.23437 9.63201 9.12405 9.49849 9.05114C9.36591 8.97727 9.20114 8.94034 9.00417 8.94034H8.55531V10.9375Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4268 11.3935V8.48438H13.2904V8.92614H11.9537V9.71591H13.1626V10.1577H11.9537V11.3935H11.4268Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5752 15.6436C8.5752 15.2293 8.91098 14.8936 9.3252 14.8936L18.8252 14.8936C19.2394 14.8936 19.5752 15.2293 19.5752 15.6436C19.5752 16.0578 19.2394 16.3936 18.8252 16.3936L9.3252 16.3936C8.91098 16.3936 8.5752 16.0578 8.5752 15.6436Z",
    fill: "#0043A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5752 18.6436C8.5752 18.2293 8.91098 17.8936 9.3252 17.8936L15.8252 17.8936C16.2394 17.8936 16.5752 18.2293 16.5752 18.6436C16.5752 19.0578 16.2394 19.3936 15.8252 19.3936L9.3252 19.3936C8.91098 19.3936 8.5752 19.0578 8.5752 18.6436Z",
    fill: "#0043A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6117_14790",
    x: -25.4248,
    y: -27.6064,
    width: 83,
    height: 87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6117_14790"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6117_14790",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6117_14790",
    x: -10.4248,
    y: -17.6064,
    width: 51,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6117_14790"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6117_14790",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6117_14790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.575195 0.393555)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfActive);
export default __webpack_public_path__ + "static/media/pdfActive.f70fae8effb403368a3bb3580838fdcb.svg";
export { ForwardRef as ReactComponent };